
<template>
  <DxPopup @hidden="onHidden" :visible="showProcessVPop" :show-close-button="true" :show-title="true" :title="menuTitle" height="850" width="1280" container=".v-application">
    <div class="h-full">
      <DxScrollView
        width="100%"
        height="100%"
        direction="both"
      >
        <OL type="A" style="font-size:12pt">
          <LI>Thông Tin Chung Về Trang Web http://hycot.hvs.com.vn:</LI>
            <OL type="1" style="font-size:10pt;">
              <LI>Người sử dụng là tất cả các khách hàng có quan hệ mua bán vật tư với công ty đóng tàu HD Hyundai Vietnam.</LI>
              <LI>Trình duyệt Web</LI>
              <img :src="require(`@/assets/images/etc/slide2_vn.jpg`)" width="90%"><br>
              <LI>Đăng nhập : Tên tài khoản (USER ID) và mật khẩu (PASSWORD)</LI>
                <OL type="i" style="font-size:10pt;">
                  <LI>Tên tài khoản (USER ID):</LI>
                    <OL type="a" style="font-size:10pt;">
                      <LI>3.1.1.	Tải khoản sử dụng là một mã số khách hàng (mỗi nhà cung cấp có một mã số khách hàng riêng do HVS tạo ra, ví dụ: Công ty A có mã số khách hàng là 10001).</LI>
                      <LI>
                      Nếu khách hàng nào chưa có mã khách hàng xin vui lòng liên hệ với chúng tôi qua địa chỉ :
                      Bộ phận Mua hàng, Phòng Vật tư, Công ty TNHH NMTB HD Hyundai-Vietnam,
                      Số 01, Mỹ Giang, Ninh Phước, Ninh Hòa, Khánh Hòa, Việt Nam,
                      Điện thoại: 0583.622101, Fax: 0583.622047, Thư điện tử: hvs@hvs.com.vn

                      </LI>
                    </OL>
                  <LI>Mật khẩu (PASSWORD):</LI>
                    <OL type="a" style="font-size:10pt">
                      <LI>Mật khẩu bắt đầu khởi tạo như sau: v + mã số khách hàng (ví dụ: User ID: 10001, Password: 10001).</LI>
                      <LI>Trang web cho phép người sử dụng tự thay đổi mật khẩu hiện tại.</LI>
                      <LI>Mỗi 3 tháng một lần, bạn phải thay đổi lại mật khẩu mới.</LI>
                      <LI>Nếu người sử dụng mất hay là quên mật khẩu, trong trường hợp này người sử dụng phải trực tiếp đến và mang theo giấy tờ có liên quan để chứng minh với phòng vật tư trước khi phòng vật tư tạo lại mật khẩu mới, nhằm bảo mật thông tin của người sử dụng.</LI>
                    </OL>
                </OL>
            </OL>
          <LI>Processing of Website:</LI>
          <img :src="require(`@/assets/images/etc/slide3_vn.jpg`)" width="90%"><br>
            <OL type="1" style="font-size:10pt;">
              <LI>Invoice and Bill Of Lading Management </LI>
                <OL>
                  <img :src="require(`@/assets/images/etc/slide6_vn.jpg`)" width="90%"><br>
                  <img :src="require(`@/assets/images/etc/slide7_vn.jpg`)" width="90%"><br>
                  <img :src="require(`@/assets/images/etc/slide8_vn.jpg`)" width="90%"><br>
                  <img :src="require(`@/assets/images/etc/slide9_vn.jpg`)" width="90%"><br>
                </OL>       
              <LI>Quotation Request : Our company will select some potentiality supplier to send quotaation request via this site.</LI>
                <OL>
                  <img :src="require(`@/assets/images/etc/slide10_vn.jpg`)" width="90%"><br>
                  <img :src="require(`@/assets/images/etc/slide11_vn.jpg`)" width="90%"><br>
                  <img :src="require(`@/assets/images/etc/slide12_vn.jpg`)" width="90%"><br>       
                </OL>
              <LI>P/I(Price Indication) : HVS will send to you a  target price in order to price indication.</LI>
                <OL>
                  <img :src="require(`@/assets/images/etc/slide13_vn.jpg`)" width="90%"><br>
                  <img :src="require(`@/assets/images/etc/slide14_vn.jpg`)" width="90%"><br>
                  <img :src="require(`@/assets/images/etc/slide15_vn.jpg`)" width="90%"><br>       
                </OL>
              <LI>Bidđing :</LI>
                <OL>
                  <img :src="require(`@/assets/images/etc/slide16_vn.jpg`)" width="90%"><br>
                  <img :src="require(`@/assets/images/etc/slide17_vn.jpg`)" width="90%"><br>
                  <img :src="require(`@/assets/images/etc/slide18_vn.jpg`)" width="90%"><br>       
                </OL>
            </OL>
            <img :src="require(`@/assets/images/etc/slide19_vn.jpg`)" width="90%"><br>  
        </OL>
      </DxScrollView>
    </div>
  </DxPopup>
</template>

<script>
import baseview from '@/components/base/baseview'
import { DxPopup } from 'devextreme-vue/popup'
import { DxScrollView } from 'devextreme-vue/scroll-view'

export default {
  name: 'processVPop',
  mixins: [baseview],
  components: {
    DxPopup,
    DxScrollView
  },
  props: {
    showProcessVPop: {
      type: Boolean,
      default() {
        return false
      }
    }
  },
  data() {
     return {
       menuTitle: 'HyCOT Process(Vietnamese)',
       openChk: false
     }
  },
  watch: {
    'showProcessVPop': {
      handler(value, oldValue) {
        if(value) {
          this.init()
        }
      },
      immediate: true
    }
  },
  methods: {
    init() {
    },
    onHidden(e) {
      this.$emit('update:showProcessVPop', false)
    }
  }
}
</script>

<style lang="scss" scoped>
</style>